var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 3.58975C9.14665 3.58975 3.59039 9.14601 3.59039 16C3.59039 22.8539 9.14665 28.4103 16.0007 28.4103C22.8546 28.4103 28.4109 22.8539 28.4109 16C28.4109 9.14601 22.8546 3.58975 16.0007 3.58975ZM1.33398 16C1.33398 7.89982 7.90047 1.33334 16.0007 1.33334C24.1009 1.33334 30.6673 7.89982 30.6673 16C30.6673 24.1002 24.1009 30.6667 16.0007 30.6667C7.90047 30.6667 1.33398 24.1002 1.33398 16Z",
    fill: "#FF7D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0139 14.0939C17.1129 14.0939 18.2195 14.8487 18.2195 15.7798V23.6474C18.2195 24.5785 17.0864 25.3333 15.9873 25.3333C14.8883 25.3333 13.7651 24.5785 13.7651 23.6474V15.7798C13.7651 14.8487 14.9148 14.0939 16.0139 14.0939ZM15.9873 8C14.5219 8 13.765 9.00643 13.765 10.2479C13.765 11.4894 14.5219 12.4958 15.9873 12.4958H16.0139C17.4793 12.4958 18.2195 11.4894 18.2195 10.2479C18.2195 9.00643 17.4793 8 16.0139 8H15.9873Z",
    fill: "#FF7D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfor);
export default __webpack_public_path__ + "static/media/infor.6409d6c6aff2ef683cba0470590def70.svg";
export { ForwardRef as ReactComponent };